import format from 'date-fns/format';
import dayjs from 'dayjs';
import ConciergeDefs from '@/store/concierge/concierge.d';
import get from 'lodash/get';
import noop from 'lodash/noop';

import IconChats from '@/assets/icons/calendar.svg';
import NumberBox from '@/components/number_box/NumberBox';

import uniqueUsersJQL from '../../scripts/mixpanel/uniqueUsersJQL.raw';
import chatsJQL from '../../scripts/mixpanel/chatsJQL.raw';
import profileVisitsJQL from '../../scripts/mixpanel/profileVisitsJQL.raw';

import { createNamespacedHelpers } from 'vuex';

const {
  mapState: mapConciergeState,
  mapActions: mapConciergeActions
} = createNamespacedHelpers('Concierge');

export default {
  name: 'DashboardDash',
  data: () => ({
    selectedPayment: 'paypal',
    dateFormat: 'YYYY-MM-DD',
    fromDate: '',
    toDate: ''
  }),
  components: {
    IconChats,
    NumberBox
  },
  created: async function() {
    this.toDate = format(dayjs(), this.dateFormat);
    this.fromDate = format(dayjs().subtract(7, 'day'), this.dateFormat);
  },
  computed: {
    ...mapConciergeState({
      currentConcierge: state => state.currentConcierge,
      conciergeRewards: state => state.conciergeRewards,
      conciergeUniqueUsers: state => state.conciergeUniqueUsers,
      conciergeChats: state => state.conciergeChats,
      conciergeProfileVisits: state => state.conciergeProfileVisits
    }),

    rewardsCount: function() {
      // Filter rewards based on dates selected
      let rewards = 0;
      const from = dayjs(this.fromDate);
      const to = dayjs(this.toDate);

      rewards = this.conciergeRewards.reduce((total, reward) => {
        const rewardDate = dayjs(reward.dateTime);
        if (rewardDate.isAfter(from) && rewardDate.isBefore(to)) {
          total += reward.rewardCount;
        }
        return total;
      }, 0);

      return rewards.toLocaleString();
    },

    uniqueUsersCount: function() {
      const count = get(this, 'conciergeUniqueUsers', 0);
      return count.toLocaleString();
    },

    chatsCount: function() {
      const count = get(this, 'conciergeChats', 0);
      return count.toLocaleString();
    },

    profileVisitsCount: function() {
      const count = get(this, 'conciergeProfileVisits', 0);
      return count.toLocaleString();
    }
  },
  watch: {
    fromDate: function() {
      this.getUniqueUsers();
      this.getChats();
      this.getProfileVisits();
    },
    toDate: function() {
      this.getUniqueUsers();
      this.getChats();
      this.getProfileVisits();
    }
  },
  methods: {
    ...mapConciergeActions({
      conciergeStore_setConciergeUniqueUsers:
        ConciergeDefs.actions.setConciergeUniqueUsers,
      conciergeStore_setConciergeChats: ConciergeDefs.actions.setConciergeChats,
      conciergeStore_setConciergeProfileVisits:
        ConciergeDefs.actions.setConciergeProfileVisits
    }),

    formatDates(fromDate, toDate) {
      let formattedDates = '';
      if (fromDate) {
        formattedDates = format(fromDate, this.dateFormat);
      }
      if (toDate) {
        formattedDates += ' ~ ' + format(toDate, this.dateFormat);
      }
      return formattedDates;
    },

    getUniqueUsers: async function() {
      const data = {
        params: JSON.stringify({
          from_date: this.fromDate,
          to_date: this.toDate,
          agent_id: this.currentConcierge.agentId,
          event_name: 'Event - send message', //event to analyze
          type: 'unique' //type of query -- can be 'unique' or 'total'
        }),
        script: uniqueUsersJQL
      };

      try {
        await this.conciergeStore_setConciergeUniqueUsers(data);
      } catch (error) {
        noop();
      }
    },

    getChats: async function() {
      const data = {
        params: JSON.stringify({
          from_date: this.fromDate,
          to_date: this.toDate,
          agent_id: this.currentConcierge.agentId,
          event_name: 'Event - Agent send message', //event to analyze
          type: 'total' //type of query -- can be 'unique' or 'total'
        }),
        script: chatsJQL
      };

      try {
        await this.conciergeStore_setConciergeChats(data);
      } catch (error) {
        noop();
      }
    },

    getProfileVisits: async function() {
      const data = {
        params: JSON.stringify({
          from_date: this.fromDate,
          to_date: this.toDate,
          agent_id: this.currentConcierge.agentId,
          event_name: 'Click - agent profile', //event to analyze
          type: 'total' //type of query -- can be 'unique' or 'total'
        }),
        script: profileVisitsJQL
      };

      try {
        await this.conciergeStore_setConciergeProfileVisits(data);
      } catch (error) {
        noop();
      }
    }
  }
};
